import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent implements OnInit {
  modalData: { [key: string]: any } = {};
  closeButtonText: string;
  userAction: string;

  constructor(private bsModalRef: BsModalRef) {  }

  ngOnInit(): void {
    this.closeButtonText = this.modalData.closeButtonText != null ? this.modalData.closeButtonText : "Close";
    if (this.modalData.warningLevel == null) {
      this.modalData.warningLevel = "danger";
    }
  }

  actionClicked() {
    this.userAction = "close";
    this.bsModalRef.hide();
  }

  cancelClicked() {
    this.userAction = "cancel";
    this.bsModalRef.hide();
  }
}
